import { CircularProgress } from '@mui/material';
import CreditIcon from 'src/assets/icons/CreditIcon.svg';
import type { CreditsTier } from './types';
import { formatGrouped } from './utils';
import {
  AddToCartButton,
  CtaRow,
  Foot,
  MathLabel,
  MathOp,
  MathRow,
  MathValue,
  PayLine,
} from './styles/CreditsFooter.styles';

export type CreditsFooterProps = {
  tier: CreditsTier;
  onAddToCart: () => void;
  addingToCart?: boolean;
  addToCartDisabled?: boolean;
  compact?: boolean;
  ctaLabel?: string;
};

const CreditsFooter = ({
  tier,
  onAddToCart,
  addingToCart,
  addToCartDisabled,
  compact,
  ctaLabel = 'Add to cart',
}: CreditsFooterProps) => {
  const total = tier.credits + tier.bonusCredits;

  return (
    <Foot compact={compact}>
      <MathRow compact={compact}>
        <div>
          <MathLabel>You pay for</MathLabel>
          <MathValue>{formatGrouped(tier.credits)} credits</MathValue>
        </div>
        <MathOp>+</MathOp>
        <div>
          <MathLabel>Bonus</MathLabel>
          <MathValue emphasis="green">
            {formatGrouped(tier.bonusCredits)} credits
          </MathValue>
        </div>
        <MathOp>=</MathOp>
        <div>
          <MathLabel>Total in your vault</MathLabel>
          <MathValue emphasis="bold">{formatGrouped(total)} credits</MathValue>
        </div>
      </MathRow>
      <CtaRow compact={compact}>
        <PayLine compact={compact}>
          Pay with <b>₹{formatGrouped(tier.price)}</b>
        </PayLine>
        <AddToCartButton
          compact={compact}
          onClick={onAddToCart}
          disabled={addToCartDisabled || addingToCart}
        >
          {addingToCart ? (
            <CircularProgress size={18} sx={{ color: 'inherit' }} />
          ) : (
            <>
              <img src={CreditIcon} alt="" width={18} height={18} />
              {ctaLabel}
            </>
          )}
        </AddToCartButton>
      </CtaRow>
    </Foot>
  );
};

export default CreditsFooter;
